import { constants } from "~/common/constants";

export const isTokenNearExpiration = (expiration: number) =>
  Date.now() + constants.CommonIntervals.TEN_MINUTES_IN_MS > expiration;
